export const THEME_OPTIONS = [
  { value: "light", label: "Light Mode", description: "Bright interface optimized for daytime use." },
  { value: "dark", label: "Dark Mode", description: "Dim interface that reduces glare during night operations." },
];

export const SOUND_PACK_OPTIONS = [
  { value: "male", label: "Male Voice Pack", description: "Voice prompts recorded with a male narrator." },
  { value: "female", label: "Female Voice Pack", description: "Voice prompts recorded with a female narrator." },
  { value: "sounds-only", label: "Sounds Only", description: "Minimal tones and beeps without spoken directions." },
  { value: "no-audio", label: "No Audio", description: "Mute all optional audio cues." },
];

export const DASHBOARD_STYLE_OPTIONS = [
  { value: "modern", label: "Modern", description: "Clean, contemporary interface with smooth animations and rounded elements." },
  { value: "retro", label: "Retro CAD/MDT (Green)", description: "Classic green-on-black terminal style reminiscent of late 90s/early 2000s police CAD systems." },
  { value: "retro-red", label: "Retro CAD/MDT (Red)", description: "Red-on-black terminal style for a more intense, alert-focused appearance." },
  { value: "windowsxp", label: "Windows XP", description: "Classic 2000s Windows XP look with blocky buttons, beveled edges, and Luna blue theme." },
  { value: "mapview", label: "Map Centered View", description: "Full-screen map with floating controls. Ideal for larger displays or when you want maximum map visibility." },
];

export const SOUND_PACK_DISCLAIMER =
  "During critical events (such as status checks), RangerVault will still play safety alerts regardless of your selection.";

// 10-Code mappings
export const TEN_CODE_MAP = {
  // Status buttons
  "emergency": "10-33",
  "out-of-service": "10-7",
  "available": "10-8",
  "busy": "10-6",
  // Incident types
  "accident": "10-50",
  "assist motorist": "10-46",
  "assist other agency": "10-70",
  "debris": "10-48",
  // Services
  "abandoned": "10-47",
};

// Helper function to get 10-code label
export const getTenCodeLabel = (value, useTenCodes) => {
  if (!useTenCodes) return null;
  const normalizedValue = (value || "").toLowerCase();
  return TEN_CODE_MAP[normalizedValue] || null;
};
